import { useLocalStorage } from 'usehooks-ts';
export const PROMOTED_FEATURE_STORAGE_KEY = 'netpurpose:application:npFeaturePromoted';
export const promotedFeatureIsEnabled = (): boolean => typeof window !== 'undefined' && window.localStorage.getItem(PROMOTED_FEATURE_STORAGE_KEY) === 'true';
export const usePromotedFeature = () => {
  return useLocalStorage(PROMOTED_FEATURE_STORAGE_KEY, false);
};